var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.682,
    height: 13.349,
    viewBox: "0 0 11.682 13.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M5.84,13.349a1.72,1.72,0,0,1-.691-.2,5.985,5.985,0,0,1-.875-.521,9.815,9.815,0,0,1-2.1-2.047A10.961,10.961,0,0,1,.117,2.246,1.293,1.293,0,0,1,.989,1.193C1.774.936,2.584.692,3.4.467A10.786,10.786,0,0,1,5.84,0,10.8,10.8,0,0,1,8.284.467c.9.244,1.808.529,2.409.726a1.29,1.29,0,0,1,.871,1.053,10.958,10.958,0,0,1-2.057,8.335,9.806,9.806,0,0,1-2.1,2.047,5.945,5.945,0,0,1-.874.521A1.733,1.733,0,0,1,5.84,13.349ZM3.316,5.66A.608.608,0,0,0,2.886,6.7L4.708,8.521a.6.6,0,0,0,.43.178.613.613,0,0,0,.43-.178L9.213,4.876a.6.6,0,0,0,.178-.43.611.611,0,0,0-.178-.43.607.607,0,0,0-.86,0L5.138,7.232,3.746,5.838A.605.605,0,0,0,3.316,5.66Z",
    fill: "#1d89d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.8e81a7b9ffd28e94f115dc40fd0640ee.svg";
export { ForwardRef as ReactComponent };